import React from 'react'
import {Group, Line, Rect} from 'react-konva'
import {raise, useEvent} from './events'
import {useSpring} from 'react-spring'
import {proportional} from './proportional'
import {gameElement, mouseHandler} from './utils'
import {drag} from './dragged-part'

function findCenter(points) {
    const sum = [0, 0]
    for (let i = 0; i < points.length; i += 2) {
        sum[0] += points[i]
        sum[1] += points[i + 1]
    }
    return [sum[0] / (points.length / 2), sum[1] / (points.length / 2)]
}

export function normalizePoints(points, scale = 1) {
    const center = findCenter(points)
    return points
        .inGroupsOf(2)
        .map((p) => [p[0] - center[0], p[1] - center[1]])
        .flatten()
        .map((a) => a * scale)
}

function Patch({ data }) {
    const state = data('patch')
    const props = useSpring({
        opacity: state.isActive ? 1 : 0,
        y: state.isActive ? 938 : 532,
        config: {mass: 3, tension: 250, friction: 30},
    })
    useEvent('shape-drawn', gotShape)
    useEvent('shape-cleared', clearShape)
    useEvent('patch.mouseDown', () => {
        if (state.isActive) {
            drag(state.points.map(p => p * 2.5))
            state.points = []
            state.isActive = false
            state.isShape = false
            raise('dragging')
        }
    })
    return (
        <Group
            {...mouseHandler('patch')}
            {...proportional({
                x: 1400,
                y: props.y.value
            }, 1)}
            opacity={props.opacity.value}


        >
            <Rect
                x={-33}
                y={-220}
                shadowOffsetX={4}
                shadowOffsetY={4}
                shadowColor={'rgba(0,0,0,0.2)'}
                shadowBlur={8}
                width={160}
                height={360}
                cornerRadius={18}
                // stroke={'#999'}
                fill='#CAD8C0'

            />
            <Line
                x={50}
                y={50}
                lineCap="round"
                shadowOffsetX={4}
                shadowOffsetY={4}
                shadowColor={'rgba(0,0,0,0.2)'}
                shadowBlur={8}
                points={state.points}
                fill='whitesmoke'
                closed={true}
                tension={0.2}
                // stroke="#333"
                // strokeWidth={2}
            />
        </Group>
    )

    function gotShape(points) {
        state.points = normalizePoints(points, 0.15)
        state.isActive = true
    }

    function clearShape() {
        state.isActive = false
    }
}
Patch.z = 900
gameElement(Patch)
